var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.6,81.4c-10.6,0-19.1,8.6-19.1,19.1v231.8c0,11.8-9.6,21.4-21.4,21.4c-11.9,0-21.5-9.6-21.5-21.4V100.5 c0-11.6-9.4-21.1-21.1-21.1c-11.7,0-21.1,9.4-21.1,21.1v231.8c0,11.8-9.6,21.4-21.4,21.4c-11.8,0-21.4-9.6-21.4-21.4V100.5 c0-11.6-9.4-21.1-21.1-21.1c-11.7,0-21.1,9.4-21.1,21.1v231.8c0,11.8-9.6,21.4-21.4,21.4c-11.8,0-21.4-9.6-21.4-21.4V100.5 c0-10.6-8.6-19.1-19.1-19.1c-10.5,0-19.1,8.6-19.1,19.1v293.9c0,67.1,45.8,123.4,107.7,139.8l-30.6,543.9 c0,23.4,48.6,42.4,67.7,42.4s67.7-19,67.7-42.4L496,534.3c62-16.4,107.7-72.7,107.7-139.8l0-293.9C603.7,90,595.2,81.4,584.6,81.4 L584.6,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M853.2,81.5c-29.6,0-56.2,11.9-79.3,35.4C660.5,232.2,663.8,623.4,664.5,667.7l0.5,32h155.6V1088 c0,18,14.6,32.6,32.6,32.6s32.6-14.6,32.6-32.6l0-973.9C885.8,96.1,871.2,81.5,853.2,81.5L853.2,81.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.29b8622b4ea447967a8a73f20a943950.svg";
export { ForwardRef as ReactComponent };